import { render, staticRenderFns } from "./DataCenterDetailing.vue?vue&type=template&id=52ee2776&scoped=true&"
import script from "./DataCenterDetailing.vue?vue&type=script&lang=ts&"
export * from "./DataCenterDetailing.vue?vue&type=script&lang=ts&"
import style0 from "./DataCenterDetailing.vue?vue&type=style&index=0&id=52ee2776&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee2776",
  null
  
)

export default component.exports